import moment from "moment"
import { siteUrl } from "src/api/config"

export const fieldsInAddAction = [
    {
        type: 'peoplePicker',
        require: true,
        single: true,
        key: 'Responsible',
        current: false,
        options: [],
        title: 'Ответственный',
        placeholder: 'Введите имя сотрудника',
        width: 'w-full tablet:w-[calc(50%-10px)]'
    },
    {
        type: 'select',
        require: true,
        key: 'Meeting',
        title: 'Совещание',
        placeholder: 'Выберите из списка',
        width: 'w-full tablet:w-[calc(50%-10px)]'
    },
    {
        type: 'textArea',
        key: 'Description',
        require: true,
        title: 'Описание',
        placeholder: 'Введите описание действия',
        width: 'w-full'
    },
    {
        type: "date",
        require: true,
        key: "DateForDone",
        minDate: moment(new Date()).subtract(7, 'days').toDate(),
        title: "Срок выполнения",
        placeholder: "дд.мм.гггг",
        width: "w-full"
    }
]

export const fieldsInAddActionСomponent = [
    {
        type: 'peoplePicker',
        require: true,
        single: true,
        key: 'Responsible',
        current: false,
        options: [],
        title: 'Ответственный',
        placeholder: 'Введите имя сотрудника',
        width: 'w-full tablet:w-[calc(50%-10px)]'
    },
    {
        type: 'select',
        require: true,
        key: 'Meeting',
        title: 'Совещание',
        placeholder: 'Выберите из списка',
        width: 'w-full tablet:w-[calc(50%-10px)]'
    },
    {
        type: 'textArea',
        key: 'Description',
        require: true,
        title: 'Описание',
        placeholder: 'Введите описание действия',
        width: 'w-full'
    },
    {
        type: "date",
        require: true,
        key: "DateForDone",
        minDate: moment(new Date()).subtract(7, 'days').toDate(),
        title: "Срок выполнения",
        placeholder: "дд.мм.гггг",
        width: "w-full"
    }
]

export const fieldsInAddActionСomponentForFiveWhyCard = [
    {
        type: 'peoplePicker',
        require: true,
        single: true,
        key: 'Responsible',
        current: false,
        options: [],
        title: 'Ответственный',
        placeholder: 'Введите имя сотрудника',
        width: 'w-[calc(50%-10px)]'
    },
    {
        type: 'select',
        require: true,
        key: 'Meeting',
        title: 'Совещание',
        placeholder: 'Выберите совещание',
        width: 'w-[calc(50%-10px)]'
    },
    {
        type: 'textArea',
        key: 'Description',
        require: true,
        title: 'Описание',
        placeholder: 'Введите описание действия',
        width: 'w-full'
    },
    {
        type: "date",
        require: true,
        key: "DateForDone",
        minDate: moment(new Date()).subtract(7, 'days').toDate(),
        title: "Срок выполнения",
        placeholder: "дд.мм.гггг",
        width: "w-[calc(50%-10px)]"
    },
    {
        type: 'select',
        require: false,
        key: 'SDCA',
        title: 'SDCA инструмент',
        noticeIcon: true,
        placeholder: 'Выберите SDCA инструмент',
        width: 'w-[calc(50%-10px)]'
    },
]

export const fieldsInCardAction = [
    {
        type: 'select',
        require: true,
        key: 'Status',
        title: 'Статус',
        placeholder: 'Выберите из списка',
        width: 'w-full'
    },
    {
        type: 'select',
        require: true,
        key: 'Meeting',
        title: 'Совещание',
        searchable: true,
        placeholder: 'Выберите из списка',
        width: 'w-full'
    },
    {
        type: 'peoplePicker',
        require: true,
        single: true,
        key: 'Responsible',
        current: false,
        options: [],
        title: 'Ответственный',
        placeholder: 'Введите имя сотрудника',
        width: 'w-full tablet:w-[calc(50%-10px)]'
    },
    {
        type: "date",
        require: true,
        key: "DateForDone",
        title: "Срок выполнения",
        placeholder: "Выберите дату",
        minDate: moment(new Date()).subtract(7, 'days').toDate(),
        width: "w-full tablet:w-[calc(50%-10px)]"
    },
    {
        type: 'textArea',
        key: 'Description',
        require: true,
        title: 'Описание',
        placeholder: 'Введите описание действия',
        width: 'w-full'
    }
]